import { UseQueryOptions, useQuery } from "@tanstack/react-query"
import type * as Api from "../../@client/api.ts"
import { get } from "../get.ts"
import { useHandleAsyncSafely } from "./use-handle-async-safely"

export function useQueryGet<ActionName extends keyof Api.GET>(
  url: ActionName,
  input: Api.Input[ActionName],
  queryOptions?: Omit<
    UseQueryOptions<
      Api.Output[ActionName],
      Error,
      Api.Output[ActionName],
      (ActionName | Api.Input[ActionName])[]
    >,
    "queryKey" | "queryFn"
  >,
  requestInit?: RequestInit
) {
  const handleAsyncSafely = useHandleAsyncSafely<Api.Output[ActionName]>()
  return useQuery({
    retry: false,
    ...queryOptions,
    queryKey: [url, input],
    queryFn: () =>
      handleAsyncSafely(() =>
        get(url, input, requestInit ? requestInit : { headers: {} })
      ),
  })
}
